export type GoogleAnalyticsErrorEventBase = {
  event: string;
  step: string;
  error_type: string;
  message: string;
};

export type GoogleAnalyticsFormErrorEvent = GoogleAnalyticsErrorEventBase & {
  field: string;
};

export enum GoogleAnalyticsErrorTypes {
  VALIDATION = 'validation',
  SERVER_ERROR = 'server_error',
  BAD_REQUEST = 'bad_request',
  CLIENT_ERROR = 'client_error',
  NOT_FOUND = 'not_found',
  NETWORK_ERROR = 'network_error',
  TIMEOUT = 'timeout',
  UNKNOWN_ERROR = 'unknown_error',
}
